export default __webpack_public_path__ + "static/media/trash can.bff19143.svg";